import request from "@/api/request"
import Router from "@/router"
import * as auth from '@/libs/auth'
import {
    encryptAES,
    decryptAES
} from "@/libs/encrypt-utils";

export function login(params) {

    return request.post('api/Auth/Login', params);
    //验证登录
    request.post('api/Auth/Login', params).then(resp => {
        return resp;
    }).catch(err => {
        console.log(err.response.data);
        return err.response.data;
    });

    // .then(resp => {
    //     if (resp.code == "200") {
    //         //成功之后设置cookie
    //         return true;
    //     } else {
    //         return false;
    //     }
    // })
}

export function loginSms(params) {
    return request.post('api/Auth/LoginSMS', params);
}

export function logout() {
    //JWT在颁发时就已固定,无法删除或强制过期,此处仅为记录日志
    return request.post('api/Auth/Logout');
}

// 发送手机验证码
export function sendSmsCode(hospId, phone) {
    return request.get(`api/auth/GetCaptcha?hospId=${hospId}&mobile=${phone}`);
}

// 发送手机验证码 V2.0 ，加上图形验证码功能，匹配通过后才能发送
export function sendSmsVerificationCode(hospId, phone, captchaKey, captchaCode) {
    let params = {
        hospId,
        phone,
        captchaKey,
        captchaCode,
    };
    return request.post(`api/auth/sendSmsCode`, params)
}

// 获取图片验证码
export function getCaptchaImage() {
    return request.get('/api/auth/captcha')
}

// 判断手机验证码是否正确
export function checkSmsCode(phone, code) {
    let postParam = {
        mobile: phone,
        code: code
    };
    return request.post(`api/auth/CheckCaptcha`, postParam);

}

// 注册新用户
export function addUser(params) {
    //202408 post前脱敏处理
    params.idcard = encryptAES(params.idcard);
    params.mobile = encryptAES(params.mobile);
    params.password = encryptAES(params.password);
    return new Promise(function (resolve, reject) {
        request.post("api/User/Register", params).then(res => {
            if (res && res.code == 200) {
                if (res.data && res.data.mobile) {
                    res.data.mobile = decryptAES(res.data.mobile);
                }
                resolve(res);
            }
        })
    })
}

// 获取已登录的用户信息
export function getLoginedUser() {
    return auth.getUser();
}

// 获取用户关联的体检人员信息
export function getUserProfiles() {
    if (auth.loggedIn()) {
        let uid = auth.getUser().id;
        return new Promise(function (resolve, reject) {
            request.get(`/api/user/getprofile?account_id=${uid}`).then(res => {
                if (res && res.code == 200) {
                    res.data.forEach(p => {
                        p.idcard = decryptAES(p.idcard);
                        p.phone = decryptAES(p.phone)
                    });
                }
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        });
    } else {
        Router.push("/login");
    }

    /*
    if (auth.loggedIn()) {
        let uid = auth.getUser().id;
        return request.get(`/api/user/getprofile?account_id=${uid}`);
    } else {
        Router.push("/login");
    }*/
}

export function getUserState() {
    return request.get('/api/user/getUserState');
}

//
export function addProfile(params) {
    //202408 post前脱敏处理
    params.idcard = encryptAES(params.idcard);
    params.phone = encryptAES(params.phone);

    return request.post("api/user/addprofile", params);
}

// 更新单个体检人员信息
export function updateProfile(params) {
    return request.post("api/user/updateprofile", params);
}

// 更新密码
export function updatePassword(params) {
    // let postParam = {
    //     Value: newPassword
    // };
    // 加密处理
    params.mobile = encryptAES(params.mobile);
    params.newPassword = encryptAES(params.newPassword);
    return request.post("api/auth/updatePassword", params);
}

// 检查用户密码是否过期
export function checkPasswordExpire() {
    return request.post("api/user/CheckPasswordExpire");
}

// 删除体检人员信息
export function deleteProfile(profileId) {
    let postParam = {
        Value: profileId.toString()
    };
    return request.post(`api/user/deleteprofile`, postParam);
}

// 获取微信openId
export function wxAuth(hospId, code) {
    return request.get("api/auth/wxauth", {
        params: {
            hospId,
            code
        }
    });
}

// 获取联空单点登录用户信息
export function ssoUser(hospId, code) {
    return request.get("openApi/sso/getuser", {
        params: {
            hospId,
            auth_code: code
        }
    });
}

// 获取单点登录用户信息后自动注册或登录
export function ssoLogin(hospId, user) {
    return request.post("api/auth/ssoLogin", {
        hospId,
        user
    });
}